import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import { classNames } from "./utils";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  iconAfter?: ReactNode;
  iconBefore?: ReactNode;
  loading?: boolean;
  size?: "small" | "medium" | "large";
  tone?: "primary" | "secondary" | "quiet" | "danger";
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    children,
    className,
    disabled,
    iconAfter,
    iconBefore,
    loading = false,
    size = "medium",
    tone = "primary",
    type = "button",
    ...props
  },
  ref,
) {
  return (
    <button
      className={classNames("am-button", `am-button--${tone}`, `am-button--${size}`, className)}
      disabled={disabled || loading}
      ref={ref}
      type={type}
      {...props}
    >
      {loading ? <span aria-hidden="true" className="am-spinner am-spinner--small" /> : iconBefore}
      <span>{children}</span>
      {iconAfter}
    </button>
  );
});

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  size?: "small" | "medium";
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { children, className, label, size = "medium", type = "button", ...props },
  ref,
) {
  return (
    <button
      aria-label={label}
      className={classNames("am-icon-button", `am-icon-button--${size}`, className)}
      ref={ref}
      type={type}
      {...props}
    >
      {children}
    </button>
  );
});

